<template>
  <!-- 送货通知 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left" style="display: flex;">
        <el-button
          v-if="hasPermiss('admin:delivery_notice:smsNotice')"
          class="glo_btnItems"
          @click="phoneDialog()"
          >电话通知</el-button
        >
        <el-button
          v-if="hasPermiss('admin:delivery_notice:smsNotice')"
          class="glo_btnItems"
          @click="msgDialog()"
          >短信通知</el-button
        >
        <el-button
          v-if="hasPermiss('admin:delivery_notice:sysNotice')"
          class="glo_btnItems"
          @click="doSendNotice()"
          >公众号/系统通知</el-button
        >
        <el-button
          v-if="hasPermiss('admin:delivery_notice:getDeliveryNoticeRecord')"
          class="glo_btnItems"
          @click="noticeLog()"
          >通知记录</el-button
        >
        <el-button
          v-if="hasPermiss('admin:delivery_notice:change:time')"
          class="glo_btnItems"
          @click.stop="updateWaybillDeliveryTime()"
          >更改时间</el-button
        >
        <div>
          <el-button-group style="display: flex;">
          <el-button class="glo_btnItems" @click="printIt()"
            >打印</el-button
          >
          <el-button
                  @click.stop="printSetting()"
                  size="mini"
                  type="primary"
                  icon="el-icon-setting"
                  class="glo_btnItems"
                  style="margin-left: 2px;min-width: 1px;"
                  ></el-button
                >
        </el-button-group>
        </div>
        <!-- <el-button
          style="margin-top: 10px"
          class="glo_bgcMainColor"
          @click="printIt()"
          >打印</el-button
        > -->
        <el-button
          class="glo_btnItems"
          @click="changeWay()"
          >更改交货方式</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <!-- <el-form-item class="queryItems" label="客户单号:">
          <el-input
            clearable
            v-model="queryData.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>-->
        <el-form-item class="queryItems" label="运单号:">
          <el-input
            clearable
            v-model="queryData.waybillNumber"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="客户名称:">
          <el-input
            clearable
            v-model="queryData.customerName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item class="queryItems" label="客户编号:">
          <el-select
            filterable
            clearable
            v-model="queryData.region"
            placeholder="请输入"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item class="queryItems" label="通知状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.noticeStatus"
            placeholder="请输入"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item class="queryItems" label="送货方式:">
          <el-select
            filterable
            clearable
            v-model="queryData.sendMethodConfDictId"
            placeholder="请输入"
          >
            <el-option
              v-for="item in send_methodList"
              :key="item.confDictId"
              :label="item.key"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="当前网点:">
          <!-- <el-select
            filterable
            clearable
            v-model="queryData.currentDeptId"
            placeholder="请输入"
          >
            <el-option
              v-for="item in storageList"
              :key="item.documentId"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select> -->
          <dept-tree
            v-model="queryData.currentDeptIds"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
        <el-form-item class="queryItems" label="终端网点:">
          <!-- <el-select
            filterable
            clearable
            v-model="queryData.endDeptId"
            placeholder="请输入"
          >
            <el-option
              v-for="item in storageList"
              :key="item.documentId"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select> -->
          <dept-tree v-model="queryData.endDeptIds" :is-storage="1"></dept-tree>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="470px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="hasPermiss('admin:delivery_notice:phoneNotice')"
                class="rbtns"
                @click.stop="phoneDialog(scope.row)"
                >电话通知</el-button
              >
              <el-button
                v-if="hasPermiss('admin:delivery_notice:smsNotice')"
                class="rbtns"
                @click.stop="msgDialog(scope.row)"
                >短信通知</el-button
              >
              <el-button
                v-if="hasPermiss('admin:delivery_notice:sysNotice')"
                class="rbtns"
                @click.stop="doSendNotice(scope.row)"
                >公众号/系统通知</el-button
              >
              <el-button
                v-if="
                  hasPermiss('admin:delivery_notice:getDeliveryNoticeRecord')
                "
                class="rbtns"
                @click.stop="noticeLog(scope.row)"
                >通知记录</el-button
              >
              <el-button
                v-if="hasPermiss('admin:delivery_notice:change:time')"
                class="rbtns"
                @click.stop="updateWaybillDeliveryTime(scope.row)"
                >更改时间</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">责任核定</el-dropdown-item>
                  <el-dropdown-item command="b">赔款过账</el-dropdown-item>
                  <el-dropdown-item command="c">赔款反过账</el-dropdown-item>
                  <el-dropdown-item command="d">责任核定过账</el-dropdown-item>
                  <el-dropdown-item command="d"
                    >责任核定反过账</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 短信通知 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      :dialogFooter="false"
      @diaConfirmBtn="diaConfirmBtn1('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-button
          @click="diaConfirmBtn1('dialogFormRef')"
          size="small"
          class="glo_bgcMainColor"
          style="margin-bottom: 10px"
          >发送短信</el-button
        >
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="80px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItems"
            prop="isAuto"
            label="发送方式"
            style="padding-right: 10px; min-width: 374px"
          >
            <!-- <el-select v-model="dialogForm.isAuto" placeholder="请选择">
              <el-option label="自动发送" value="1"></el-option>
              <el-option label="手动发送" value="0"></el-option>
            </el-select> -->
            <el-radio-group v-model="dialogForm.isAuto">
              <el-radio :label="1">自动发送</el-radio>
              <el-radio :label="0">手动发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="target"
            label="通知对象"
            style="width: unset; padding-right: 10px"
          >
            <el-radio-group
              v-model="dialogForm.target"
              @change="changeTargetType"
            >
              <el-radio :label="1">默认（收货人）</el-radio>
              <el-radio :label="2">收、发货人</el-radio>
              <el-radio :label="3">发货人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-tabs
            v-model="dialogForm.activeTab"
            style="width: 100%; margin-right: 3%"
          >
            <el-tab-pane
              label="收货人"
              name="rece"
              style="padding-right: 2px"
              v-if="dialogForm.target != 3"
            >
              <el-form-item
                class="dislogFormTextarea"
                prop="receiveContent"
                label="自动发送短信模板"
                v-if="dialogForm.isAuto == '1'"
                style="margin-top: 10px"
              >
                <el-input
                  type="textarea"
                  rows="2"
                  v-model="receSmsModel"
                  placeholder="根据模板内容自动生成显示对应的短信信息"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item
                class="dislogFormTextarea"
                prop="receiveContent"
                label="手动发送短信内容"
                v-if="dialogForm.isAuto == '0'"
                style="margin-top: 10px"
              >
                <el-input
                  type="textarea"
                  rows="2"
                  v-model="dialogForm.receiveContent"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane
              label="发货人"
              name="sender"
              style="padding-right: 2px"
              v-if="dialogForm.target != 1"
            >
              <el-form-item
                class="dislogFormTextarea"
                prop="sendContent"
                label="自动发送短信模板"
                v-if="dialogForm.isAuto == '1'"
                style="margin-top: 10px"
              >
                <el-input
                  type="textarea"
                  rows="2"
                  v-model="sendSmsModel"
                  placeholder="根据模板内容自动生成显示对应的短信信息"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item
                class="dislogFormTextarea"
                prop="sendContent"
                label="手动发送短信内容"
                v-if="dialogForm.isAuto == '0'"
                style="margin-top: 10px"
              >
                <el-input
                  type="textarea"
                  rows="2"
                  v-model="dialogForm.sendContent"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>

          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div class="glo_Table">
        <div>已选运单号手机列表</div>
        <el-table
          header-align="center"
          ref="mytable"
          :data="msgtableData"
          border
          stripe
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          ></el-table-column>
          <!-- <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>-->
          <template v-for="(item, index) in tabelHeadeTitle2">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
          <el-table-column fixed="right" label="操作" min-width="60px">
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <el-button
                  v-if="msgtableData.length > 0"
                  class="rbtns"
                  @click.stop="delItems(scope.row, scope.$index)"
                  >移除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </myDialog>

    <!-- 电话通知 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef2')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog2"
          ref="dialogFormRef2"
          :model="dialogForm2"
          label-width="140px"
          :rules="rulesForm2"
        >
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="phoneUserName"
            label="电话接听人:"
          >
            <el-input v-model="dialogForm2.phoneUserName" readonly></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="4"
              v-model="dialogForm2.remarks"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 通知记录 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3('dialogFormRef3')"
    >
      <div class="glo_Table">
        <el-table
          header-align="center"
          ref="mytable"
          :data="tableDataLog"
          border
          stripe
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          ></el-table-column>
          <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>
          <template v-for="(item, index) in tabelHeadeTitle3">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
        </el-table>
      </div>
    </myDialog>

    <!-- 更改交货日期 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4('dialogFormRef4')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog4"
          ref="dialogFormRef4"
          :model="dialogForm4"
          label-width="140px"
          :rules="rules4"
        >
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="waybillNumber"
            label="运单号:"
          >
            <el-input v-model="dialogForm4.waybillNumber" disabled></el-input>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="deliveryTime"
            label="交货日期:"
          >
            <el-date-picker
              v-model="dialogForm4.deliveryTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              default-time="12:00:00"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>

          <el-form-item class="queryItems" label="运单号:">
            <el-input
              clearable
              v-model="queryData.waybillNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="客户名称:">
            <el-input
              clearable
              v-model="queryData.customerName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item class="queryItems" label="送货方式:">
            <el-select
              filterable
              clearable
              v-model="queryData.sendMethodConfDictId"
              placeholder="请输入"
            >
              <el-option
                v-for="item in send_methodList"
                :key="item.confDictId"
                :label="item.key"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="当前网点:">
            <el-select
              filterable
              clearable
              v-model="queryData.currentDeptId"
              placeholder="请输入"
            >
              <el-option
                v-for="item in storageList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="终端网点:">
            <el-select
              filterable
              clearable
              v-model="queryData.endDeptId"
              placeholder="请输入"
            >
              <el-option
                v-for="item in storageList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      modelTypeVal="调度配载模块"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="'admin:delivery_notice:print:add:common'"
      :edit-permission="'admin:delivery_notice:print:edit:common'"
      :del-permission="'admin:delivery_notice:print:delcommon'"
    ></my-print>
    <myDialog
      diaWidth="800px"
      dialogTitle="修改交货方式"
      :isShowDialog="showChangeWayDialog"
      @handleCloseDia="handleCloseChangeWayDialog"
      @diaCancelBtn="handleCloseChangeWayDialog"
      @diaConfirmBtn="diaConfirmBtnChangeWayDialog()"
    >
      <el-form label-position="right" label-width="100px">
        <el-form-item label="运单号">
          <el-input v-model="changeWayForm.waybillNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="交货方式">
          <el-radio-group v-model="changeWayForm.sendMethodConfDictId" @change="changeSendMethod">
            <el-radio
              :label="sendMethod.confDictId"
              v-for="sendMethod in send_methodList"
              :key="sendMethod.confDictId"
              >{{ sendMethod.val }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="到付送货费">
              <el-input v-model="changeWayForm.receiveSendFee" :disabled="changeWayForm.sendMethod !== '送货上门'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到付其他费用">
              <el-input v-model="changeWayForm.receiveOtherFee" :disabled="changeWayForm.sendMethod !== '送货上门'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </myDialog>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
import MyPrint from "@/components/print/MyPrint.vue";
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    queryBtns,
    MyPrint,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "送货通知",
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        apiName: "/admin/v3/tms/waybill/delivery/notice/getDeliveryNoticeList", //导出的数据列表接口名
        pageType: "DeliveryNotice", //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      //  -----  查询  ------
      queryData: {
        currentDeptId: "",
        customerName: "",
        customerNumber: "",
        endDeptId: "",
        endDeliveryTime: "",
        endUpdateTime: "",
        noticeStatus: "",
        sendMethodConfDictId: "",
        startDeliveryTime: "",
        startUpdateTime: "",
        waybillNumber: "",
        currentDeptId: null,
        endDeptId: null,
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "最新通知时间",
        },
        {
          value: "1",
          label: "交货日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "通知状态",
          field: "noticeStatusShow",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "电话通知",
          field: "phoneCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "短信通知",
          field: "smsCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "公众号/系统通知",
          field: "noticeCount",
          width: "170",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "电话通知备注",
          field: "phoneRemark",
          width: "170",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "短信通知备注",
          field: "smsRemark",
          width: "170",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "公众号/系统通知备注",
        //   field: "smsRemark",
        //   width: "220",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "最新通知类型",
          field: "sendPlatformShow",
          width: "140",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "最新通知人",
          field: "updateUserName",
          width: "140",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "最新通知时间",
          field: "updateTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人电话",
          field: "receivePhone",
          width: "140",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货省",
          field: "receiveProvinceName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人地址",
          field: "receiveAddress",
          width: "150",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单要求",
          field: "rnRequireName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      // 短信通知表格
      tabelHeadeTitle2: [
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "手机号",
        //   field: "aaaaaaa",
        //   width: "120",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "是否有效",
          field: "isValidShow",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货人电话",
          field: "receivePhone",
          width: "140",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货省",
          field: "receiveProvinceName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      // 通知记录
      tabelHeadeTitle3: [
        // {
        //   name: "运单号",
        //   field: "waybillNumber",
        //   width: "160",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        // {
        //   name: "客户单号",
        //   field: "customerOrderNumber",
        //   width: "120",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "通知类型",
          field: "sendPlatformShow",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "电话接听人",
          field: "receiveName",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "接收号码",
          field: "receiveAccount",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "通知备注",
          field: "remarks",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "通知人",
          field: "createUserName",
          width: "110",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "通知时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "运单ID",
        //   field: "aaaaaaa",
        //   width: "110",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据
      tableDataLog: [], //  通知记录
      msgtableData: [], //  短信通知

      allCheck: false, //  全选
      sortName: "送货通知列表模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "DeliveryNotice", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        isAuto: 1,
        target: 1,
        activeTab: "rece",
        content: "",
        remarks: "",
      },
      rulesForm: {},
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "",
      diaWidth2: "40%",
      dialogForm2: {
        // 弹窗表单数据
        expandId: "",
        phoneUserName: "",
        remarks: "",
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      rules4: {
        deliveryTime: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog3: false,
      dialogTitle3: "通知记录",
      diaWidth3: "80%",

      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog4: false,
      dialogTitle4: "更改交货日期",
      diaWidth4: "40%",
      dialogForm4: {
        // 弹窗表单数据
        deliveryTime: "",
        waybillSpiltId: "",
        waybillNumber: "",
      },

      // ==== 弹窗组件属性 end ====
      storageList: [],
      send_methodList: [],
      sendSmsModel: "",
      receSmsModel: "",
      classNameArr: [
        {
          name: "出库单",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCkPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCkPrintDataV5VO",
      showChangeWayDialog: false,
      changeWayForm: {
        waybillSpiltId:'',
        waybillNumber:'',
        sendMethodConfDictId:'',
        sendMethod:'',
        receiveSendFee:'',
        receiveOtherFee:''
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;

    this.getData();
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
    this.getDepList();
    this.getsend_methodList();
    this.getSmsModels();
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    // this.getData();
  },
  mounted() {},
  watch: {},
  methods: {
    changeWay() {
      if(this.selectTableData.length !== 1){
        this.$message.warning("请选择一条记录操作");
        return
      }
      const row = this.selectTableData[0]
      this.changeWayForm = {
        ...row,
        
      }

      this.showChangeWayDialog = true;
    },
    async getSmsModels() {
      const models = await this.$API.runList({
        number: "admin_sms_model_list_v5",
      });
      this.sendSmsModel = models.filter(
        (item) => item.noticeType === "fa:notice_type"
      )[0].content;
      this.receSmsModel = models.filter(
        (item) => item.noticeType === "shou:notice_type"
      )[0].content;
    },
    changeSendMethod(confDictId){
      const sendMethod = this.send_methodList.filter(item=>item.confDictId == confDictId)[0]
      this.changeWayForm.sendMethod = sendMethod.val
    },
    getDepList() {
      this.$COMAPI.getObjectUserDownList("storage").then((res) => {
        this.storageList = res || [];
      }); //获取网点列表
    },
    // 修改交货日期
    updateWaybillDeliveryTime(row) {
      if (!row) {
        if (this.selectTableData.length < 1) {
          this.$message.error(
            "请选择需要 修改交货日期 的运单"
          ).showClose = true;
          return false;
        }
        row = this.selectTableData[0];
      }
      this.isShowDialog4 = true;
      this.dialogForm4.waybillSpiltId = row.waybillSplitId;
      this.dialogForm4.waybillNumber = row.waybillNumber;
      this.dialogForm4.deliveryTime = row.deliveryTime;
    },
    getsend_methodList() {
      this.$COMAPI.getConfDictValDownList("send_method").then((res) => {
        this.send_methodList = res || [];
      }); //送货方式
    },
    // 通知记录
    noticeLog(row) {
      let id = "";
      if (row) {
        id = row.expandId;
      } else {
        if (this.selectTableData.length != 1) {
          this.$message.error("请选择一条单据查看通知记录").showClose = true;
          return false;
        }
        id = this.selectTableData[0].expandId;
      }
      this.$API.getDeliveryNoticeRecordV5({ expandId: id }).then((res) => {
        this.tableDataLog = res.data.result.data || [];
        this.isShowDialog3 = true;
      });
    },
    // 短信通知
    msgDialog(row) {
      let datas = [];
      if (row) {
        datas.push(row);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要 短信通知 的运单").showClose = true;
          return false;
        }
        datas = this.selectTableData;
      }
      this.msgtableData = datas || [];
      this.isShowDialog = true;
      this.dialogTitle = "短信通知";
    },
    // 手机通知
    phoneDialog(row) {
      if (!row) {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要 电话通知 的运单").showClose = true;
          return false;
        }
        row = this.selectTableData[0];
      }
      this.isShowDialog2 = true;
      this.dialogTitle2 = "电话通知";
      this.dialogForm2.expandId = row.expandId;
      this.dialogForm2.phoneUserName = row.receiveContacts;
    },
    // 公众号/系统通知
    doSendNotice(row) {
      let datas = [];
      if (row) {
        datas.push(row);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要 系统通知 的运单").showClose = true;
          return false;
        }
        datas = this.selectTableData;
      }
      let array = [];
      datas.forEach((item) => {
        let objs = {
          expandId: item.expandId || "",
        };
        array.push(objs);
      });
      this.$confirm("确定发送公众号/系统通知给发货人？")
        .then((res) => {
          this.$API
            .wechatNoticeV5({
              waybillReqs: array,
            })
            .then((res) => {
              this.$message.success(res.data.message || "");
              this.isShowDialog = false;
              this.getData();
            });
        })
        .catch((err) => {});
    },
    // 修改运单
    WaybillEdit() {
      this.$router.push("/WaybillManage/WaybillEdit");
    },
    // 修改运单
    transportPlan() {
      this.$router.push({
        path: "/WaybillManage/TransportationPlann",
        query: {
          id: 1,
        },
      });
    },
    // 移除
    delItems(row, idx) {
      this.$confirm("确认要移除当前运单号吗?", "提示:")
        .then(() => {
          let array = JSON.parse(JSON.stringify(this.msgtableData)) || [];
          array.splice(idx, 1);
          this.msgtableData = array;
        })
        .catch(() => {});
    },

    // 过账
    guoZhang() {
      this.$router.push({
        path: "/WaybillManage/Posting",
        query: {
          id: "1",
        },
      });
    },
    // 反过账
    fanGuoZhang() {},
    // 终止运单
    stopYd() {},
    // 合单
    heDan() {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        // 弹窗表单数据
        isAuto: 1,
        content: "",
        remarks: "",
        target: 1,
        activeTab: "rece",
      };
    },
    //  弹窗确认保存事件(短信)
    diaConfirmBtn1() {
      let datas = JSON.parse(JSON.stringify(this.msgtableData));
      let array = [];
      datas.forEach((item) => {
        let objs = {
          expandId: item.expandId || "",
        };
        array.push(objs);
      });
      this.$API
        .smsNoticeV5({
          isAuto: this.dialogForm.isAuto,
          target: this.dialogForm.target,
          sendContent: this.dialogForm.sendContent,
          receiveContent: this.dialogForm.receiveContent,
          remarks: this.dialogForm.remarks,
          waybillReqs: array,
        })
        .then((res) => {
          this.$message.success(res.data.message || "");
          this.isShowDialog = false;
          this.getData();
        });
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        expandId: "",
        phoneUserName: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      let param = {
        expandId: this.dialogForm2.expandId,
        phoneUserName: this.dialogForm2.phoneUserName,
        remarks: this.dialogForm2.remarks,
      };
      this.$API.phoneNoticeV5(param).then((res) => {
        this.$message.success(res.data.message || "");
        this.isShowDialog2 = false;
        this.getData();
      });
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        expandId: "",
        phoneUserName: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      this.isShowDialog3 = false;
    },
    //
    handleCloseDia3() {
      this.isShowDialog3 = false;
    },

    //  弹窗确认保存事件
    diaConfirmBtn4() {
      if (!this.dialogForm4.deliveryTime) {
        this.$message.error("交货日期不能为空");
        return false;
      }

      this.$API
        .updateWaybillDeliveryTime({
          deliveryTime: this.dialogForm4.deliveryTime || "",
          waybillSpiltId: this.dialogForm4.waybillSpiltId || "",
        })
        .then((res) => {
          this.isShowDialog4 = false;
          this.$message.success(res.data.message || "操作成功");
          this.getData();
        });
    },
    //
    handleCloseDia4() {
      this.isShowDialog4 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      // this.$message.success("你点我干嘛");
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          yd: "123",
        },
      });
    },

    changeTargetType() {
      const target = this.dialogForm.target;
      if (target === 1) {
        this.dialogForm.activeTab = "rece";
      }
      if (target === 3) {
        this.dialogForm.activeTab = "sender";
      }
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      let param = JSON.parse(JSON.stringify(this.queryData));

      param.pageStart = this.pageStart;
      param.pageTotal = this.pageTotal;

      let startDeliveryTime = ""; //送货
      let endDeliveryTime = "";
      let startUpdateTime = ""; //通知-开始
      let endUpdateTime = ""; //通知-结束

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

      if (this.timeType == "0") {
        startUpdateTime = startTime;
        endUpdateTime = endTime;
      }
      if (this.timeType == "1") {
        startDeliveryTime = startTime;
        endDeliveryTime = endTime;
      }
      param.startDeliveryTime = startDeliveryTime;
      param.endDeliveryTime = endDeliveryTime;
      param.startUpdateTime = startUpdateTime;
      param.endUpdateTime = endUpdateTime;
      if (param.currentDeptIds && param.currentDeptIds.length > 0) {
        param.currentDeptIds = param.currentDeptIds.join(",");
      }
      if (param.endDeptIdS && param.endDeptIdS.length > 0) {
        param.endDeptIdS = param.endDeptIdS.join(",");
      }
      this.$API.wtl_getDeliveryNoticeList(param).then((res) => {
        this.className = res.data.result.className || "";
        this.tableData = res.data.result.data || [];
        this.pageCount = res.data.result.pageCount || 0;

        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        currentDeptId: "",
        customerName: "",
        customerNumber: "",
        endDeptId: "",
        endDeliveryTime: "",
        endUpdateTime: "",
        noticeStatus: "",
        sendMethodConfDictId: "",
        startDeliveryTime: "",
        startUpdateTime: "",
        waybillNumber: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
      }
      if (a === "jtdc") {
        // 新版导出
        this.isShowDialog_dc = true;
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==详情
      if (type === "a") {
        this.$router.push("/WaybillManage/WaybillDetails");
      }
      // d==删除
      if (type === "d") {
        this.delBtns(val);
      }
    },

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
    printDataSource(rows) {
      return new Promise((resolve, reject) => {
        this.$API
          .ckPrintData({
            waybillSplitIds: rows.map((d) => d.waybillSplitId),
          })
          .then((res) => {
            const result = res.data.result;
            resolve(result);
          })
          .catch((err) => {});
      });
    },
    printIt() {
      this.$refs.myPrint.printEvent(this.selectTableData);
    },
    printSetting() {
      this.$refs.myPrint.printSetting();
    },
    handleCloseChangeWayDialog() {
      this.showChangeWayDialog = false;
    },
    async diaConfirmBtnChangeWayDialog() {
      await this.$API.changeSendWay(this.changeWayForm)
      this.$message.success("修改成功")
      this.showChangeWayDialog = false;
      this.getData()
    },
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}

.glo_dialogForm {
  min-height: 120px !important;
}
.dislogFormTextarea {
  /deep/ .el-form-item__label {
    line-height: 30px;
  }
}
</style>
